<template>
    <div class="loadingContent" v-loading="true">
    </div>
</template>

<script>
export default {
    name: "Loading"
}
</script>

<style scoped lang="less">
.loadingContent{
    width: 100%;
    height: 500px;
    background-color: white;
}
</style>
